/**
 * `modules/action/dropdown.js`
 * - 開閉アニメーション（アコーディオン、ドロップダウン、スライドダウンなど）
 *
 * 使用方法:
 * - import {initDropdown} from "../modules/action/dropdown.js";
 * - initDropdown();
 *
 * 詳細:
 * trigger - [data-action="dropdown"]
 * search  - [data-dropdown]
 *           nextElementSibling（最大5件隣を検索）
 *           見つからない場合、子要素を検索
 */


import {slideToggle} from "../../utils/index.js";

export function initDropdown(button, listeners, speed = 400) {

  const toggleSlide = () => {
    let content = button.nextElementSibling;
    const maxChecks = 5; // 最大5つ先まで探す
    let count = 0;

    // `data-dropdown` が見つかるまで、最大5回まで次の要素を探索
    while (content && !content.matches("[data-dropdown]") && count < maxChecks) {
      content = content.nextElementSibling;
      count++;
    }

    // `data-dropdown` が直接の次の要素でない場合、子要素を探索
    if (!content || !content.matches("[data-dropdown]")) {
      content = button.parentElement.querySelector("[data-dropdown]");
    }

    if (!content) return;

    button.classList.toggle("is-open");
    content.classList.toggle("is-open");
    slideToggle(content, speed);
  };

  button.addEventListener("click", toggleSlide);
  listeners.push([button, "click", toggleSlide]);
}


/**
 *
  <div class="dropdown">
    <button data-action="dropdown">メニュー 1</button>
    <div data-dropdown>
      <p>ここにメニュー1の詳細コンテンツが表示されます。</p>
    </div>
  </div>

 * */